import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { WorkTypeReportsData } from './WorkTypeReportsData.types.tsx';

const RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS = 'WORK_TYPE_PROJECTS_LIMITS';

export const workTypeProjectsLimitsResource: RouteResource<WorkTypeReportsData> =
	createResource<WorkTypeReportsData>({
		type: RESOURCE_TYPE_WORK_TYPE_PROJECTS_LIMITS,
		getKey: () => 'workTypeProjectsLimits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-work-type-projects-limits", jiraSpaEntry: "async-resource-work-type-projects-limits" */ './GetDataGetData.tsx'
			),
	});
